import _ from 'lodash'
import Backbone from 'backbone'
import config from 'scoreboard/components/config'
import template from './generic-overview-info.hbs'
import basicInfo from 'scoreboard/components/overview-info/basic-info.hbs'
import templateCopies from 'scoreboard/components/overview-info/template-copies.hbs'
import metadata from 'scoreboard/components/metadata'
import i18n from 'scoreboard/components/i18n'
import replicatedMessage from 'scoreboard/components/replicated-message'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import RelatedItemsList from 'scoreboard/related-items/related-items-list'
import conductor from 'scoreboard/components/conductor'
import projects from 'scoreboard/projects/projects'
import sections from 'scoreboard/components/sections'
import Dataset from 'scoreboard/datasets/model/dataset'

function removeEmptyValues(hash) {
	var values = _.reduce(hash, function(acc, value, key) {
		if (!_.isEmpty(value) || _.isNumber(value) || _.isBoolean(value)) {
			acc.push({key: key, value: value})
		}
		return acc
	}, [])
	return values
}

var GenericOverviewInfo = Backbone.View.extend({

	// this.model is a domain object (e.g. Dashboard)
	// this.options.heading is the title of the dialog

	className: 'overview-info',

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		var heading = i18n.get('common.info.withArg',
			metadata[this.model.section].createTypeCode)

		let details = {
			// Common to all Types
			'common.replication.replicated': replicatedMessage(this.model)
		}
		let modelAttrs = _.cloneDeep(this.model.attributes)

		// Take care of org specific context values
		const isOrg = this.model.section === 'organizations'
		var context = _.extend({
			section: this.model.section,
			heading: heading,
			details: removeEmptyValues(details),
			isOrg
		}, modelAttrs)

		if (isOrg) {
			this.gatherOrgTemplateInformation(context)
		} else {
			this.gatherTemplateInformation(context)
		}

		if (!config.displayIds) {
			delete context.id
		}
		this.$el.empty().append(template(context))
		this.$('.basic-info').replaceWith(basicInfo(context))
		this.$('.template-copies').replaceWith(templateCopies(context))

		let templateObject = this.model.get('template')
		if (templateObject && templateObject.organization) {
			this.tooltip = new TooltipAndDetails({
				selector: this.$('.value .template-id'),
				tooltipContent: () => templateObject.organization.label,
				tooltipOptions: {
					extraClass: 'organization-template-tooltip',
					placement: 'above'
				}
			})
		}

		// Organizations won't have related items, so we won't display the panel
		if (!isOrg) {
			this.relatedItemsList = new RelatedItemsList({model: this.model})
			this.$('.related').html(this.relatedItemsList.el)
			this.relatedItemsList.render()
		}

		return this
	},

	gatherOrgTemplateInformation: function(modelAttrs) {
		const getReplicationValue = attrs => {
			let value = ''
			let replication = attrs.replicated
			let replicationCascaded = attrs.replicatedCascaded
			if (replication) {
				value += i18n.get('common.yes')
				if (replicationCascaded) {
					value += ' ' + i18n.get('common.replication.cascadingToDescendants')
				}
			} else {
				value += i18n.get('common.no')
			}

			return value
		}

		let projectsMap = config.enableProjects ? projects._projectMap : null
		let treeNodes = _.get(this.options, 'gardener.tree.nodes')
		let copies = _.isNil(modelAttrs.copies) ? [] : modelAttrs.copies

		// get template link first for the org we are viewing
		this.getTemplateHref(modelAttrs)

		_.each([...copies, modelAttrs], org => {
			let orgNode = treeNodes[org.id]
			if (config.replicationEnabled) {
				let copyAttrs = _.extend({}, org, orgNode)
				org.replicationValue = getReplicationValue(copyAttrs)
			}

			if (projectsMap) {
				let project = projectsMap.get(orgNode.projectId)
				org.projectLabel = project.get('label')
			}
			this.getCopyHref(org)
		})

		this.populateTemplateDatasetField(modelAttrs)
	},

	gatherTemplateInformation: function(ctx) {
		// get links for template, copies
		this.getTemplateHref(ctx)
		if (!_.isEmpty(ctx.copies)) {
			_.each(ctx.copies, copy => {
				this.getCopyHref(copy)
			})
		}
	},

	getTemplateHref: function(ctx) {
		if (ctx.templateId) {
			ctx.templateHref = this.model.section === 'organizations' ?
				`organizations/${ctx.templateId}/${conductor.section()}` :
				`${sections.toUrl(ctx.section)}/${ctx.templateId}`
		}
	},

	populateTemplateDatasetField: function(ctx) {
		if (this.model.get('dataset')) {
			const dataset = new Dataset(this.model.get('dataset'))
			const datasetId = dataset.get('id')
			const fieldId = this.model.get('datasetFieldId')
			const field = dataset.combinedFieldsById[fieldId]
			const datasetLabel = dataset.get('label')
			const fieldLabel = field.label

			const datasetFieldText = i18n.get(
				'common.organization.template.dataset.field.description',
				fieldLabel, datasetLabel
			)
			const datasetFieldHref = `datasets/${datasetId}`

			_.extend(ctx, {
				datasetFieldHref,
				datasetFieldText,
				datasetLabel,
				hasDataset: true
			})
		} else {
			_.extend(ctx, { hasDataset: false })
		}
	},

	getCopyHref: function(copy) {
		let section = sections.toUrl(conductor.section())
		copy.href = this.model.section === 'organizations' ?
			`organizations/${copy.id}/${section}` :
			`${section}/${copy.id}`
	},

	remove () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.tooltip, this.relatedItemsList], 'remove')
	}

})

export default GenericOverviewInfo
export { removeEmptyValues }

GenericOverviewInfo.__filename__ = 'components/overview-info/generic-overview-info.js'
